import ProfilePage from "./profile.container";

export default ProfilePage;
